/**
 * Waits so that at least ``minMs`` milliseconds have passed since ``startedAt``.
 * Use before hiding a route loader when the network/cache returned too quickly.
 */
export async function waitMinimumElapsedSince(
  startedAt: number,
  minMs: number
): Promise<void> {
  const elapsed = Date.now() - startedAt;
  const wait = minMs - elapsed;
  if (wait > 0) {
    await new Promise<void>((resolve) => {
      setTimeout(resolve, wait);
    });
  }
}
